import { render, staticRenderFns } from "./MyStart.vue?vue&type=template&id=604437c8&scoped=true&"
import script from "./MyStart.vue?vue&type=script&lang=js&"
export * from "./MyStart.vue?vue&type=script&lang=js&"
import style0 from "./MyStart.vue?vue&type=style&index=0&id=604437c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604437c8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
